import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { FilterData, Filters, SortData, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { PNLUiState } from "@domains/aggregates/Reports/PNLUiState";
import UnderstandingReportName, { UnderstandingReportType, } from "@domains/entities/Reports/UnderstandingSection";
import { ESortOrder } from "@domains/utils/sort";
import { accountDetails } from "@frameworks/web/di";
import { PNLErrorEnum, } from "../action-interfaces/Reports/PNLReport";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon, StockDetailsEnum, } from "../action-interfaces/Reports/HoldingReport";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { isLoginSourceEMT, triggerDownloadReportCallback, } from "@domains/utils/emtReportCallback";
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import { ERports, } from "../action-interfaces/Reports/DashboardSummary";
import abortControllerClass from "@domains/utils/abortControllerClass";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import { pnlDataFlagsInit } from "@domains/mapper/Reports/DashboardMapper";
class PNLReportPresenter {
    constructor(useCases, commonUsecase, downloadPDFReports, downloadExcelReports, sendEmailReports, actions, understandUseCase, GTMService, useCasesStream, dashBoardUsecase, dashboardActions, worker, abortController) {
        this.useCases = useCases;
        this.commonUsecase = commonUsecase;
        this.downloadPDFReports = downloadPDFReports;
        this.downloadExcelReports = downloadExcelReports;
        this.sendEmailReports = sendEmailReports;
        this.actions = actions;
        this.understandUseCase = understandUseCase;
        this.GTMService = GTMService;
        this.useCasesStream = useCasesStream;
        this.dashBoardUsecase = dashBoardUsecase;
        this.dashboardActions = dashboardActions;
        this.worker = worker;
        this.abortController = abortController;
        this.initPNLSummary = {
            totalPnl: "",
            totalPnlChangePercent: "",
            realisedPnl: "",
            realisedPnlChangePercent: "",
            unrealisedPnl: "",
            unrealisedPnlChangePercent: "",
            closePriceDate: "",
            totalMarketValue: "",
            totalClosingCostValue: "",
            totalSellCostValue: "",
            editableCount: 0,
            totalSellValue: "",
            totalInvestment: "",
            daysPnLChange: ""
        };
        this.initDashboardSummary = {
            dashboardSummary: [],
            pnlSummary: this.initPNLSummary,
            pnlDetail: [],
            pnlDataFlags: pnlDataFlagsInit
        };
        this.dashboardSummary = this.initDashboardSummary;
        this.dashboardpnlSymbols = [];
        this.viewTransactionClick = false;
        this.viewTransactionClickScrollerPosition = 0;
        this.pnlSideBarTab = StockDetailsEnum.OVERVIEW;
        this.LThreeWindowbackClick = false;
        this.streamToggle = false;
        this.streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
            streamKeys[4],
        ];
        this.isSummarize = false;
        this.searchState = "";
        this.filterState = new FilterData(new Filters("Filter By", [
            { title: "Realized P&L", key: "realisedPnl", selected: false },
            { title: "Unrealized P&L", key: "unrealisedPnl", selected: false },
            { title: "Profit Only", key: "profit", selected: false },
            { title: "Loss Only", key: "loss", selected: false },
            { title: "Show editable transactions", key: "editable", selected: false },
        ]), new Filters(" ", []), new Filters("productAssetFilter", []));
        this.sortState = new SortData("", "", ESortOrder.UNCHANGED);
        this.sortStateArray = new Array(new SortData("Alphabetical", "displayName", ESortOrder.DESC), new SortData("P&L %", "totalPnLChangePercent", ESortOrder.UNCHANGED), new SortData("P&L absolute", "totalPnL", ESortOrder.UNCHANGED), new SortData("Realized P&L %", "realisedPnLChangePercent", ESortOrder.UNCHANGED), new SortData("Realized P&L abs", "realisedPnL", ESortOrder.UNCHANGED), new SortData("Unrealized P&L %", "unrealisedPnLChangePercent", ESortOrder.UNCHANGED), new SortData("Unrealized P&L abs", "unrealisedPnL", ESortOrder.UNCHANGED));
        this.emailAndDownload = false;
        this.symbols = [];
        this.subscribe = false;
        this.removeOneFilter = (clearThisFilter, tabName) => {
            let clearFound = false;
            let updatedFilter = [];
            let keyFound = null;
            Object.entries(this.filterState).forEach((val) => {
                var _a;
                if (clearFound)
                    return;
                if (val[0] && ((_a = val[1]) === null || _a === void 0 ? void 0 : _a.filters)) {
                    updatedFilter = val[1].filters.map((x) => {
                        if (x.title === clearThisFilter) {
                            x.selected = false;
                            clearFound = true;
                            keyFound = val[0];
                            this.removeOneFilterFromSession(val, x);
                        }
                        return x;
                    });
                }
            });
            if (clearFound) {
                if (keyFound == "simpleFilter")
                    keyFound = this.filterState.simpleFilter.name;
                this.getFilteredPNLReportData(Object.assign(Object.assign({}, this.filterState), { assetFilter: new Filters("", []), [keyFound]: new Filters(keyFound, updatedFilter) }), tabName);
            }
        };
        this.removeSessionFilters = () => {
            let filters = [
                "Filter By",
                "simpleFilter",
            ];
            filters.forEach((x) => {
                if (x)
                    sessionStorage.removeItem(x);
            });
            Object.values(this.filterState).forEach((filter) => {
                if (filter && filter.filters && filters.includes(filter.name))
                    filter.filters.forEach((sinngleFilt) => {
                        sinngleFilt.selected = false;
                    });
            });
        };
    }
    getDashboardData(req) {
        this.dashboardActions.hideError(ERports.PNL);
        this.dashboardActions.loader(ERports.PNL);
        this.initPNLStore();
        this.initPNLDashboard();
        this.dashBoardUsecase.execute({
            onSuccess: (data) => {
                this.dashboardSummary = data;
                this.dashboardActions.getDashboardSummary({
                    data: data.dashboardSummary,
                    summary: data.pnlSummary,
                    pnlDataFlags: data.pnlDataFlags
                }, ERports.PNL);
                this.dashboardpnlSymbols = data.pnlDetail
                    .map((x) => x.quote.symbol)
                    .filter((val) => val.length > 0);
                this.getPNLDashboardStream(this.streamToggle);
                this.dashboardActions.stopLoader(ERports.PNL);
            },
            onError: (error) => {
                this.dashboardActions.setError({
                    error,
                    isOpen: true,
                }, ERports.PNL);
                this.dashboardActions.stopLoader(ERports.PNL);
            },
        }, req);
    }
    async downloadTransactionReport(requestData) {
        const loginSource = await accountDetails.getLoginSrc();
        this.actions.hideError(PNLErrorEnum.DOWNLOADSTATUS);
        const payload = {
            fromDate: requestData.fromDate,
            toDate: requestData.toDate,
            assetType: requestData.assetType,
            duration: requestData.duration,
            scripIdentifier: requestData.scripIdentifier,
            reportName: ReportName.PNL,
            urlParts: "/" + requestData.transactionType,
            accodes: requestData.accountId,
        };
        if (isLoginSourceEMT(loginSource)) {
            triggerDownloadReportCallback("GET", ReportType.EXCEL, ReportName.PNL + "/" + requestData.transactionType, {
                fromDate: requestData.fromDate,
                toDate: requestData.toDate,
                assetType: requestData.assetType,
                scripIdentifier: requestData.scripIdentifier.toString(),
                accodes: requestData.accountId,
                duration: requestData.duration,
            }, loginSource);
        }
        if (requestData.reportType === ReportType.PDF)
            this.downloadPDFReports.execute({
                onSuccess: (data) => {
                    this.actions.setError({
                        isOpen: data,
                        error: null,
                    }, PNLErrorEnum.DOWNLOADSTATUS);
                },
                onError: (error) => {
                    this.actions.setError({
                        isOpen: false,
                        error,
                    }, PNLErrorEnum.DOWNLOADSTATUS);
                },
            }, payload);
        else
            this.downloadExcelReports.execute({
                onSuccess: (data) => {
                    this.actions.setError({
                        isOpen: data,
                        error: null,
                    }, PNLErrorEnum.DOWNLOADSTATUS);
                },
                onError: (error) => {
                    this.actions.setError({
                        isOpen: false,
                        error,
                    }, PNLErrorEnum.DOWNLOADSTATUS);
                },
            }, payload);
    }
    getPNLReportData(requestData) {
        this.actions.toggleShimmer(true);
        this.actions.hideError(PNLErrorEnum.ERROR_DATA);
        this.actions.hideEmptyValidation();
        this.initPNLStore();
        this.initPNLDashboard();
        if (this.abortController.abortController.signal)
            this.abortController.abortController.abort();
        if (this.abortController.abortController.signal.aborted)
            this.abortController = new abortControllerClass(new AbortController());
        const payload = {
            fromDate: requestData.fromDate,
            toDate: requestData.toDate,
            assetType: requestData.assetType,
            duration: requestData.duration,
            abortSignal: this.abortController.abortController.signal,
        };
        if (requestData.accountIds)
            payload.accountIds = requestData.accountIds;
        this.useCases.execute({
            onSuccess: (data) => {
                if (!data) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL];
                    this.actions.setEmptyValidation({ emptyValidation });
                    this.sortState = new SortData("", "", ESortOrder.UNCHANGED);
                }
                let FilterInSession = JSON.parse(sessionStorage.getItem("simpleFilter"));
                if (FilterInSession && FilterInSession.length > 0 && data) {
                    FilterInSession.forEach((x) => {
                        if (x.value === true)
                            this.filterState.simpleFilter.filters.forEach((y) => {
                                if (y.key === x.key[1])
                                    y.selected = true;
                            });
                    });
                }
                this.filterState.simpleFilter = new Filters(this.filterState.simpleFilter.name, this.filterState.simpleFilter.filters);
                this.actions.toggleShimmer(false);
                this.PNLReportData = {
                    PnLData: data,
                    SearchData: this.searchState,
                    IsSummarize: this.isSummarize,
                    FilterData: this.filterState,
                    SortData: this.sortStateArray,
                };
                this.symbols = data.pnLDetails
                    .map((holding) => holding.quote.symbol)
                    .filter((sym) => sym !== "");
                let combinedState = new PNLUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
                this.commonUsecase
                    .getModifiedData(this.PNLReportData, combinedState, this.subscribe)
                    .then((summarizedPNLReportData) => {
                    let filterAppliedAndEmpty = this.filterErrorHandle(summarizedPNLReportData);
                    let eleFoundAndEmpty = this.searchErrorHandle(summarizedPNLReportData);
                    let emptyValidation;
                    if (filterAppliedAndEmpty)
                        emptyValidation = EmptyValidation[EmptyIcon.FILTER];
                    else if (eleFoundAndEmpty)
                        emptyValidation = EmptyValidation[EmptyIcon.SEARCH];
                    else if (filterAppliedAndEmpty && eleFoundAndEmpty)
                        emptyValidation = EmptyValidation[EmptyIcon.FILTER];
                    if (filterAppliedAndEmpty || eleFoundAndEmpty) {
                        this.actions.setEmptyValidation({ emptyValidation });
                        this.actions.getPNLReportData(summarizedPNLReportData);
                        this.actions.toggleShimmer(false);
                    }
                    else {
                        this.actions.getPNLReportData(summarizedPNLReportData);
                        this.getPNLStreamData(this.streamToggle);
                    }
                    ;
                });
            },
            onError: (error) => {
                let errorCode = error.getErrorCode();
                if (errorCode !== DOMException.ABORT_ERR.toString() &&
                    typeof error != "undefined") {
                    this.actions.toggleShimmer(false);
                    this.PNLReportData = {
                        PnLData: {
                            pnLSummary: null,
                            pnLDetails: [],
                            pnlDataFlags: { bodProcessInfoMessage: "", isBodEnabled: false }
                        },
                        SearchData: this.searchState,
                        FilterData: this.filterState,
                        SortData: [this.sortState],
                        IsSummarize: this.isSummarize,
                    };
                    this.actions.getPNLReportData(this.PNLReportData);
                    this.actions.setError({
                        error,
                        isOpen: true,
                    }, PNLErrorEnum.ERROR_DATA);
                }
            },
        }, payload);
    }
    getPNLStreamData(subscribe) {
        const symb = subscribe ? this.symbols : [];
        if (!symb.length)
            return;
        this.worker.onmessage = (event) => {
            const { reportData, type } = event.data;
            if (type === ReportName.PNL)
                this.PNLReportData = reportData;
        };
        this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, async (mappedData) => {
            if (symb.includes(mappedData.symbol) && this.streamToggle) {
                this.worker.postMessage({
                    type: ReportName.PNL,
                    streamData: mappedData,
                    reportData: this.PNLReportData,
                });
                this.sessionFilters();
                let combinedState = new PNLUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
                const updateStreamData = await this.commonUsecase.getModifiedData(this.PNLReportData, combinedState, this.subscribe);
                this.actions.getPNLReportData({
                    PnLData: updateStreamData.PnLData,
                    SearchData: this.searchState,
                    FilterData: this.filterState,
                    SortData: updateStreamData.SortData,
                    IsSummarize: this.isSummarize,
                });
            }
        }, symb, this.streamMapKey);
    }
    getPNLDashboardStream(subscribe) {
        const symbDashb = subscribe ? this.dashboardpnlSymbols : [];
        if (!symbDashb.length)
            return;
        this.worker.onmessage = (event) => {
            const { reportData, type } = event.data;
            if (type === ReportName.PNLDASHBOARD)
                this.dashboardSummary = reportData;
        };
        this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, async (mappedData) => {
            if (symbDashb.includes(mappedData.symbol) && this.streamToggle) {
                this.worker.postMessage({
                    type: ReportName.PNLDASHBOARD,
                    streamData: mappedData,
                    reportData: this.dashboardSummary,
                });
                const updateStreamData = await this.commonUsecase.dashboardSummarize(this.dashboardSummary, this.isSummarize);
                this.dashboardActions.getDashboardSummary({
                    data: updateStreamData.dashboardSummary,
                    summary: updateStreamData.pnlSummary,
                    pnlDataFlags: updateStreamData.pnlDataFlags
                }, ERports.PNL);
            }
        }, symbDashb, this.streamMapKey);
    }
    getSummarizePNLReportData(isSummarize, activeSubtabName) {
        this.isSummarize = isSummarize;
        let combinedState = new PNLUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.SummarizeValues}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.PNL} | ${activeSubtabName}`, `${this.isSummarize
            ? ReportsGTMConstants.Enable
            : ReportsGTMConstants.Disable}`));
        this.commonUsecase
            .getModifiedData(this.PNLReportData, combinedState, this.subscribe)
            .then((summarizedPNLReportData) => this.actions.getPNLReportData(summarizedPNLReportData));
        this.commonUsecase
            .dashboardSummarize(this.dashboardSummary, this.isSummarize)
            .then((data) => {
            this.dashboardActions.getDashboardSummary({
                data: data.dashboardSummary,
                summary: data.pnlSummary,
                pnlDataFlags: {
                    isBodEnabled: data.pnlDataFlags.isBodEnabled,
                    bodProcessInfoMessage: data.pnlDataFlags.bodProcessInfoMessage,
                }
            }, ERports.PNL);
        });
    }
    async getSearchPNLReportData(input, activeSubtabName) {
        this.searchState = input;
        // this.actions.toggleShimmer(true);
        // this.filterState = this.positionReportData.FilterData; // set it to initial state
        this.searchState.length > 0
            ? this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Search}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.PNL} | ${activeSubtabName}`, `${input}`))
            : null;
        let combinedState = new PNLUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        this.actions.hideEmptyValidation();
        const searchedPNLReportData = await this.commonUsecase.getModifiedData(this.PNLReportData, combinedState, this.subscribe);
        let eleFoundAndEmpty = this.searchErrorHandle(searchedPNLReportData);
        if (eleFoundAndEmpty) {
            const emptyValidation = EmptyValidation[EmptyIcon.SEARCH];
            this.actions.getPNLReportData(searchedPNLReportData);
            this.actions.setEmptyValidation({ emptyValidation });
        }
    }
    searchErrorHandle(searchedPNLReportData) {
        let eleFoundAndEmpty = false;
        if (searchedPNLReportData &&
            searchedPNLReportData.PnLData.pnLDetails.length > 0) {
            this.actions.getPNLReportData(searchedPNLReportData);
        }
        else {
            eleFoundAndEmpty = true;
        }
        return eleFoundAndEmpty;
    }
    filterErrorHandle(filterededPNLReportData) {
        var _a, _b;
        let filterApplied = false;
        if (filterededPNLReportData &&
            filterededPNLReportData.PnLData.pnLDetails.length > 0) {
            this.actions.toggleShimmer(false);
            this.actions.getPNLReportData(filterededPNLReportData);
        }
        else {
            for (let key in this.filterState) {
                if (((_b = (_a = this.filterState[key]) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.filter((x) => x.selected).length) > 0)
                    filterApplied = true;
            }
        }
        return filterApplied;
    }
    async getFilteredPNLReportData(filterState, activeSubtabName) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.filterState = filterState;
        // this.actions.toggleShimmer(true);
        let combinedState = new PNLUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        this.actions.hideEmptyValidation();
        const filterededPNLReportData = await this.commonUsecase.getModifiedData(this.PNLReportData, combinedState, this.subscribe);
        let filterApplied = this.filterErrorHandle(filterededPNLReportData);
        if (filterApplied) {
            let emptyValidation = EmptyValidation[EmptyIcon.FILTER];
            this.actions.setEmptyValidation({ emptyValidation });
            this.actions.getPNLReportData(filterededPNLReportData);
        }
        if (((_c = (_b = (_a = filterededPNLReportData.FilterData) === null || _a === void 0 ? void 0 : _a.assetFilter) === null || _b === void 0 ? void 0 : _b.filters) === null || _c === void 0 ? void 0 : _c.find((x) => x.selected === true)) ||
            ((_f = (_e = (_d = filterededPNLReportData.FilterData) === null || _d === void 0 ? void 0 : _d.simpleFilter) === null || _e === void 0 ? void 0 : _e.filters) === null || _f === void 0 ? void 0 : _f.find((x) => x.selected))) {
            this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.FilterIcon} ${ReportsGTMConstants.Apply}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding} | ${activeSubtabName}`, `${this.filterState.simpleFilter.filters
                .map((x) => (x.selected === true ? x.title.concat(" ") : null))
                .join("")} ${(_g = this.filterState.assetFilter) === null || _g === void 0 ? void 0 : _g.filters.map((x) => (x.selected === true ? x.title.concat(" ") : null)).join("")}`));
        }
    }
    async getSortedPNLReportData(newSortState, GATagCall, activeSubtabName) {
        // if clicked on the same key then change the order otherwise sort in assending (default)
        this.sortState = newSortState;
        // this.actions.toggleShimmer(true);
        let combinedState = new PNLUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        GATagCall
            ? this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.OrderIcon} | ${ReportsGTMConstants.Apply}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.PNL} | ${activeSubtabName}`, `${this.sortState.displayName}`))
            : null;
        const sortedPNLReportData = await this.commonUsecase.getModifiedData(this.PNLReportData, combinedState, this.subscribe);
        this.actions.getPNLReportData(sortedPNLReportData);
    }
    downloadAndSendReportPNL(activeSubtabName, email, download) {
        this.viewTransactionClickScrollerPosition = 0;
        if (email && download) {
            this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${email.reportType === ReportType.PDF
                ? ReportsGTMConstants.PDF
                : ReportsGTMConstants.EXCEL}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.PNL} | ${activeSubtabName}`, `${ReportsGTMConstants.Download} / ${ReportsGTMConstants.Email}  | ${ReportsGTMConstants.Submit}`));
            this.emailAndDownload = true;
        }
        if (email) {
            this.emailReport(email, activeSubtabName);
        }
        if (download) {
            if (download.reportType === ReportType.PDF) {
                this.downloadPdfReport(download, activeSubtabName);
            }
            else {
                this.donwloadExcelReport(download, activeSubtabName);
            }
        }
        this.emailAndDownload = false;
    }
    async donwloadExcelReport(download, activeSubtabName) {
        this.actions.hideError(PNLErrorEnum.DOWNLOADSTATUS);
        const loginSource = await accountDetails.getLoginSrc();
        const downloadPayload = {
            fromDate: download.fromDate,
            toDate: download.toDate,
            reportName: ReportName.PNL,
            assetType: download.assetType,
            duration: download.duration,
            subReportName: ReportName.PNL,
        };
        if (download === null || download === void 0 ? void 0 : download.accodes) {
            downloadPayload.accodes = download === null || download === void 0 ? void 0 : download.accodes;
            downloadPayload.isConsolidated = download === null || download === void 0 ? void 0 : download.isConsolidated;
        }
        if (download.underlyingAsset)
            downloadPayload.underlyingAsset = download.underlyingAsset;
        if (download.expiryMonth)
            downloadPayload.expiryMonth = download.expiryMonth;
        if (download === null || download === void 0 ? void 0 : download.isPwdProtected)
            downloadPayload.isPwdProtected = download === null || download === void 0 ? void 0 : download.isPwdProtected;
        if (!this.emailAndDownload)
            this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.EXCEL}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.PNL} | ${activeSubtabName}`, `${ReportsGTMConstants.Download}  | ${ReportsGTMConstants.Submit}`));
        if (isLoginSourceEMT(loginSource)) {
            triggerDownloadReportCallback("GET", ReportType.EXCEL, ReportName.PNL, {
                fromDate: download.fromDate,
                toDate: download.toDate,
                assetType: download.assetType,
            }, loginSource);
        }
        else {
            this.downloadExcelReports.execute({
                onSuccess: (data) => {
                    this.actions.setError({
                        isOpen: data,
                        error: null,
                    }, PNLErrorEnum.DOWNLOADSTATUS);
                },
                onError: (error) => {
                    this.actions.setError({
                        isOpen: false,
                        error,
                    }, PNLErrorEnum.DOWNLOADSTATUS);
                },
            }, downloadPayload);
        }
    }
    async downloadPdfReport(download, activeSubtabName) {
        this.actions.hideError(PNLErrorEnum.DOWNLOADSTATUS);
        const loginSource = await accountDetails.getLoginSrc();
        const downloadPayload = {
            fromDate: download.fromDate,
            toDate: download.toDate,
            assetType: download.assetType,
            duration: download.duration,
            reportName: ReportName.PNL,
        };
        if (download === null || download === void 0 ? void 0 : download.accodes) {
            downloadPayload.accodes = download === null || download === void 0 ? void 0 : download.accodes;
            downloadPayload.isConsolidated = download === null || download === void 0 ? void 0 : download.isConsolidated;
        }
        if (download.underlyingAsset)
            downloadPayload.underlyingAsset = download.underlyingAsset;
        if (download.expiryMonth)
            downloadPayload.expiryMonth = download.expiryMonth;
        if (download === null || download === void 0 ? void 0 : download.isPwdProtected)
            downloadPayload.isPwdProtected = download === null || download === void 0 ? void 0 : download.isPwdProtected;
        this.emailAndDownload
            ? null
            : this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.PDF}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.PNL} | ${activeSubtabName}`, `${ReportsGTMConstants.Download}  | ${ReportsGTMConstants.Submit}`));
        if (isLoginSourceEMT(loginSource)) {
            triggerDownloadReportCallback("GET", ReportType.PDF, ReportName.PNL, {
                fromDate: download.fromDate,
                toDate: download.toDate,
                assetType: download.assetType,
            }, loginSource);
        }
        else {
            this.downloadPDFReports.execute({
                onSuccess: (data) => {
                    this.actions.setError({
                        isOpen: data,
                        error: null,
                    }, PNLErrorEnum.DOWNLOADSTATUS);
                },
                onError: (error) => {
                    this.actions.setError({
                        isOpen: false,
                        error,
                    }, PNLErrorEnum.DOWNLOADSTATUS);
                },
            }, downloadPayload);
        }
    }
    emailReport(email, activeSubtabName) {
        this.actions.hideError(PNLErrorEnum.EMAILSTATUS);
        const emailPayload = {
            toDate: email.toDate,
            fromDate: email.fromDate,
            reportType: email.reportType,
            emailIds: email.emailIds,
            assetType: email.assetType,
            duration: email.duration,
            reportName: ReportName.PNL,
        };
        if (email.underlyingAsset)
            emailPayload.underlyingAsset = email.underlyingAsset;
        if (email.expiryMonth)
            emailPayload.expiryMonth = email.expiryMonth;
        if (email === null || email === void 0 ? void 0 : email.accodes) {
            emailPayload.accodes = email === null || email === void 0 ? void 0 : email.accodes;
            emailPayload.isConsolidated = email === null || email === void 0 ? void 0 : email.isConsolidated;
        }
        if (!this.emailAndDownload)
            this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${email.reportType === ReportType.PDF
                ? ReportsGTMConstants.PDF
                : ReportsGTMConstants.EXCEL}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.PNL} | ${activeSubtabName}`, `${ReportsGTMConstants.Email}  | ${ReportsGTMConstants.Submit}`));
        this.sendEmailReports.execute({
            onSuccess: (data) => {
                this.actions.setError({
                    isOpen: data,
                    error: null,
                }, PNLErrorEnum.EMAILSTATUS);
            },
            onError: (error) => {
                this.actions.setError({
                    isOpen: false,
                    error,
                }, PNLErrorEnum.EMAILSTATUS);
            },
        }, emailPayload);
    }
    // For removing filters
    removeFilter(filter) {
        if (filter)
            return filter.map((filter) => {
                if (filter.selected)
                    filter.selected = false;
                return filter;
            });
        return [];
    }
    async removeFilters(title, activeSubtabName) {
        return await this.getFilteredPNLReportData({
            simpleFilter: {
                name: "Filter By",
                filters: this.removeFilter(this.filterState.simpleFilter.filters),
            },
            assetFilter: this.filterState.assetFilter,
            productAssetFilter: {
                name: this.filterState.productAssetFilter.name,
                filters: this.removeFilter(this.filterState.productAssetFilter.filters),
            },
        }, activeSubtabName);
    }
    //
    getPNLUnderstandingSectionData() {
        const payload = {
            reportName: UnderstandingReportName.PNL,
            type: UnderstandingReportType.SUMMARY_FIELD,
        };
        this.understandUseCase.execute({
            onSuccess: (understandSectionData) => {
                if (understandSectionData.reportDetails.length > 0) {
                    this.actions.getPNLUnderstandingSectionData(understandSectionData);
                }
            },
            onError: (error) => {
                this.actions.setErrorUnderStandings({
                    error,
                    isOpen: true,
                });
            },
        }, payload);
    }
    storeSelectedPNLStockDetails(selectedStock) {
        this.actions.storeSelectedPNLStockDetails(selectedStock);
    }
    saveProdAssetDropDown(prodAssetFilter) {
        this.actions.saveProdAssetDropDown(prodAssetFilter);
    }
    removeOneFilterFromSession(val, x) {
        let FilterInSession = JSON.parse(sessionStorage.getItem(val[0]));
        if (FilterInSession && FilterInSession[0].value.length > 0) {
            FilterInSession[0].value.forEach((item) => {
                if (x.title === item) {
                    x.selected = false;
                    let newSessionFilter = FilterInSession[0].value;
                    const index = FilterInSession[0].value.indexOf(x.title);
                    if (index > -1)
                        FilterInSession[0].value.splice(index, 1);
                    sessionStorage.setItem(val[0], JSON.stringify([{ key: [val[0]], value: newSessionFilter }]));
                }
            });
        }
        if (val[0] === "simpleFilter" && FilterInSession.length === 1)
            sessionStorage.removeItem(val[0]);
    }
    sessionFilters() {
        let FilterInSession = JSON.parse(sessionStorage.getItem("simpleFilter"));
        if (FilterInSession && FilterInSession.length > 0) {
            FilterInSession.forEach((x) => {
                if (x.value === true)
                    this.filterState.simpleFilter.filters.forEach((y) => {
                        if (y.key === x.key[1])
                            y.selected = true;
                    });
            });
        }
    }
    pnlToggleStream(stream) {
        this.streamToggle = stream;
        this.actions.saveStreamToggle(stream);
        this.getPNLStreamData(stream);
        this.getPNLDashboardStream(stream);
    }
    initPNLStore() {
        this.PNLReportData = {
            PnLData: {
                pnLSummary: this.initPNLSummary,
                pnLDetails: [],
                pnlDataFlags: { bodProcessInfoMessage: "", isBodEnabled: false }
            },
            SearchData: this.searchState,
            FilterData: this.filterState,
            SortData: [this.sortState],
            IsSummarize: this.isSummarize,
        };
        this.actions.getPNLReportData(this.PNLReportData);
        this.symbols = [];
        this.getPNLStreamData(false);
    }
    initPNLDashboard() {
        this.dashboardSummary = this.initDashboardSummary;
        this.dashboardpnlSymbols = [];
        this.dashboardActions.getDashboardSummary({
            data: [],
            summary: this.initPNLSummary,
            pnlDataFlags: pnlDataFlagsInit
        }, ERports.PNL);
        this.getPNLDashboardStream(false);
    }
}
export default PNLReportPresenter;
